<template>
    <div>
        <div class="main">
            <div class="title">
                我的钱包
                <div @click="back" class="back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
            </div>
        </div>

        <div class="content" style="width: 100%;height:100vh;">
            <div class="wallet_card">
                <div class="wallet_title">我的总收益</div>
                <div class="wallet_money">
                    <div>
                        <div class="pfn">待提现</div>
                        <div>
                            <span style="font-size: 24px;color: #FF474C;" class="pfnb">{{dataItem ? dataItem.account || 0 : ''}}</span>&zwnj;
                            <span style="color: #FF474C;" class="pfn">元</span></div>
                    </div>
                    <div>

                        <span @click="tipRule" class="pfn btn_padding" style="color: #FFA724;">去提现</span>

                    </div>
                </div>
                <div class="money_parms">
                    <div>
                        <div class="pfn">冻结金额</div>
                        <div><span class="pfnb">{{dataItem ? dataItem.freezeAccount ||0 : ''}}</span>&zwnj; <span class="pfns">元</span>
                        </div>
                    </div>
                    <div>
                        <div class="pfn">分享收益</div>
                        <div><span class="pfnb">{{dataItem ? dataItem.shareAccount ||0 : ''}}</span>&zwnj; <span class="pfns">元</span>
                        </div>
                    </div>
                    <div>
                        <div class="pfn">介绍人收益</div>
                        <div><span class="pfnb">{{dataItem ? dataItem.recommendAccount || 0 : ''}}</span>&zwnj; <span
                                class="pfns">元</span></div>
                    </div>
                </div>
            </div>
            <div class="wallet_explain">
                <div class="explain_title">收益说明：</div>
                <div class="explain_mr">
                    <div class="pfn" style="color:#333;margin-bottom:5px;">1、什么是平台收益</div>
                    <div class="pfn">
                        平台收益是师讯平台作为奖励学员通过学习、评论等行为获得学分，进行兑换而成的收益金额；
                    </div>
                </div>
                <div class="explain_mr">
                    <div class="pfn" style="color:#333;margin-bottom:5px;">2、收益使用方法</div>
                    <div class="pfn">
                        在购买课程时可抵扣一定数额的费用，也可以在平台内申请提现；
                    </div>
                </div>
                <div class="explain_mr">
                    <div class="pfn" style="color:#333;margin-bottom:5px;">3、收益规则</div>
                    <div class="pfn">
                        收益可进行累计，在规定时间内使用，逾期则收益作废；发生退款时，收益不予退还。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// util
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        get : {
            url : '/portal/v4/user/center/wallet/getTotalRevenue'
        }
    }
}

export default {
    name: "wallet",
    extends : shixunPagePart,
    data() {
        return {
            title: '钱包 - ' + appConfig.name + ' | ' + appConfig.desc,
            apiConfig: config.apiConfig,
            enableDataItem: true,
            autoLoadDataItem: true
        }
    },
    methods: {
        back() {
            appHelper.back(this)
        },

        tipRule() {
            appHelper.showHint('暂未开放操作');
        }
    }
}
</script>
<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 4%;
    box-sizing: border-box;
    background: #fff;
}

.title {
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 20px;

    font-weight: 600;
    color: #333333;

    overflow: hidden;

}

.back {
    float: left;
    margin-top: 4px;
}


.wallet_card {
    width: 90%;
    // height: 207px;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 18px;
    margin-bottom: 64px;
    background: #fff;
    padding: 0 16px;
    box-sizing: border-box;
    padding-bottom: 22px;

}

.wallet_title {
    padding: 12px 0;

    font-size: 16px;

    font-weight: 600;
    color: #333333;


    border-bottom: 1px solid #F6F6F6;
}

.wallet_money {
    padding: 18px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #F6F6F6;

}

.pfn {

    font-size: 12px;

    font-weight: 400;
    color: #999999;

}

.pfnb {

    font-size: 18px;
    font-weight: bold;
    color: #333333;

}

.pfns {

    font-size: 8px;

    font-weight: 600;
    color: #333333;

}

.btn_padding {
    margin-top: 12px;
    padding: 4px 16px;
    display: block;
    border: 1px solid #FFA724;

    border-radius: 14px;
}

.money_parms {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
}

.wallet_explain {
    width: 90%;
    max-height: 230px;
    margin: 0 auto;
    .explain_title {

        font-size: 14px;

        font-weight: 400;
        color: #333333;

    }

    .explain_mr {
        margin-top: 12px;
    }


}


</style>
